import React, { Fragment } from "react";
import { Grid, Drawer, Paper, Fade, LinearProgress, Collapse } from "@material-ui/core";
import moment from "moment";
import { FileLoader } from "@loanbossinc/component-library";
import DrawerAttachmentsItem from "./DrawerAttachmentsItem";
import { downloadFile } from "../../utils/api";
import {
  PaddedWrapper,
  EmptyAttachmentWrapper,
  NoAttachmentsTextWrapper,
  ImageContainer,
  AttachmentHeader,
  Title,
  StyledInfo
} from "./DrawerAttachmentsStyles";

export default class DrawerAttachments extends React.Component {
  handleDownload = fileId => downloadFile(`files/${fileId}`);

  handleUpload = files => this.props.onAdd(files[0]);

  isLast = (index, fileCount) => index === fileCount - 1;

  createAttachment = (file, index) => {
    const { authentication } = this.props;

    if (authentication.isGuest && file.isPrivate) return null;

    return (
      <Fragment key={index}>
        <DrawerAttachmentsItem
          file={file}
          referenceMode={this.props.referenceMode}
          authentication={authentication}
          onRemove={this.props.onRemove}
          onUpdate={this.props.onUpdate}
          onDownload={() => this.handleDownload(file.id)}
          onOpenPdfForReference={this.props.onOpenPdfForReference}
          deleteAttachment={this.props.deleteAttachment}
          references={this.props.references}
					referencedFieldPath={this.props.referencedFieldPath}
          referenceFields={this.props.referenceFields}
        />
      </Fragment>
    );
  };

  emptyAttachmentContainer = () => (
    <>
      <EmptyAttachmentWrapper>
        <ImageContainer>
          <img src={process.env.PUBLIC_URL + "/images/Paperclip.png"} alt="" />
        </ImageContainer>
      </EmptyAttachmentWrapper>
      <br />
      <NoAttachmentsTextWrapper>No attachments for this deal</NoAttachmentsTextWrapper>
    </>
  );

  render() {
    const { files, isOpen, closeDrawer, isLoading, internalID } = this.props;

    return (
      <Fragment>
        <Drawer onClose={closeDrawer} name={`attachmentsDrawer${internalID}`} anchor="right" open={isOpen}>
          <PaddedWrapper>
            <AttachmentHeader>
              <Grid container>
                <Grid item xs={12}>
                  <Title>Attachments</Title>
                </Grid>
                <Grid item xs={10}>
                  <StyledInfo>Attachments are only accessible to users within your</StyledInfo>
                  <StyledInfo>company unless you make them public after uploading.</StyledInfo>
                </Grid>
              </Grid>
            </AttachmentHeader>

            <div className="file-loader">
              <Collapse in={!isLoading} timeout={300}>
                <Paper elevation={1}>
                  <FileLoader multiple={false} onDrop={this.handleUpload} style={{ width: "100%" }} />
                </Paper>
              </Collapse>
              <Fade in={isLoading} timeout={300}>
                <Paper elevation={1}>
                  <LinearProgress />
                </Paper>
              </Fade>
            </div>

            {files && files.length > 0 && (
              <Grid container direction="column" id="notesList">
                {files
                  .sort((fileA, fileB) => moment.utc(fileB.createdAt).unix() - moment.utc(fileA.createdAt).unix())
                  .map((file, index) => this.createAttachment(file, index, files.length))}
              </Grid>
            )}

            {files && files.length === 0 && (
              <Grid container direction="column" id="notesList" alignItems="center">
                {this.emptyAttachmentContainer()}
              </Grid>
            )}
          </PaddedWrapper>
        </Drawer>
      </Fragment>
    );
  }
}
